import { colors } from '../../styles/theme';
import GuideLayout, { GuideStep } from './GuideLayout';

const vincSteps: GuideStep[] = [
  { id: 1, title: 'Uygulamaya Giriş', description: 'YolSepetiGO uygulamasını açın ve hesabınıza giriş yapın.', image: '/images/customer-app/1.png' },
  { id: 2, title: 'Vinç Seçin', description: 'Ana ekranda "Vinç" hizmetine tıklayın. Ağır yük kaldırma için idealdir.', image: '/images/customer-app/2.png' },
  { id: 3, title: 'Konum Girin', description: 'Vinç hizmetinin gerekeceği konumu girin. Teslim noktasını belirleyin.', image: '/images/customer-app/3.png' },
  { id: 4, title: 'Yük Bilgisi', description: 'Kaldırılacak yükün tipini ve tahmini ağırlığını belirtin.', image: '/images/customer-app/4.png' },
  { id: 5, title: 'Fiyatı Görün', description: 'Vinç hizmeti için toplam ücret görüntülenir. Onaylayın.', image: '/images/customer-app/5.png' },
  { id: 6, title: 'Eşleşme Bekleyin', description: 'Talebiniz vinç operatörlerine iletildi. Onay bekleniyor.', image: '/images/customer-app/6.png' },
  { id: 7, title: 'Ödeme Yapın', description: 'Güvenli ödeme seçenekleriyle ödemenizi tamamlayın.', image: '/images/customer-app/7.png' },
  { id: 8, title: 'Operatörü Takip', description: 'Vinç operatörünüzü haritada canlı takip edin.', image: '/images/customer-app/8.png' },
];

export default function VincGuidePage() {
  return (
    <GuideLayout
      service="vinc"
      seo={{
        title: 'Vinç Talebi Nasıl Oluşturulur?',
        description: 'YolSepetiGO ile vinç talebi nasıl oluşturulur? 8 adımda vinç hizmeti alın.',
        keywords: ['vinç talebi', 'vinç hizmeti', 'ağır yük kaldırma', 'kurtarma vinci'],
      }}
      breadcrumb="Vinç"
      title="Vinç Talebi Nasıl Oluşturulur?"
      subtitle="8 kolay adımda vinç hizmeti alın. Ağır yük kaldırma işleriniz için yanınızdayız!"
      accent={{
        from: colors.secondary[500],
        to: colors.secondary[700],
        soft: colors.secondary[50],
        border: colors.secondary[200],
        strong: colors.secondary[700],
        text: colors.secondary[900],
      }}
      steps={vincSteps}
      tipsTitle="Vinç Hizmeti İpuçları"
      tips={[
        'Kaldırılacak yükün tahmini ağırlığını mümkün olduğunca doğru belirtin.',
        'Çalışma alanının vinç için uygun olduğundan emin olun.',
        'Yer altı kabloları veya engeller varsa operatöre bildirin.',
        'Büyük projeler için önceden randevu almanızı öneririz.',
      ]}
      cta={{
        title: 'Hemen Vinç Çağırın!',
        text: 'Ağır yük kaldırma ihtiyacınız mı var? Profesyonel vinç hizmeti alın.',
        label: 'Vinç Çağır',
        href: 'https://yolsepetigo.com',
        tone: 'primary',
      }}
    />
  );
}
